import { useMemo } from "react";
import { getSession } from "utils/auth";

export function useCurrentSideLinks() {
   const { user }: any = getSession();

   const links = useMemo(() => {
      return [
         {
            label: "Dashboard",
            url: "#/admin/school/dashboard",
            icon: "/icons/dashboard.svg",
            role: ["sch_admin"],
            children: [
               {
                  label: "Admin Dashboard",
                  url: "/admin/school/dashboard",
               },
               {
                  label: "Enquiries",
                  url: "/admin/school/enquiries",
               },
               {
                  label: "Reviews",
                  url: "/admin/school/reviews",
               },
               {
                  label: "Applications",
                  url: "/admin/school/applications",
               },
            ],
         },
         {
            label: "Dashboard",
            url: "/admin/dashboard",
            icon: "/icons/dashboard.svg",
            role: ["super_admin", "edusko_sub_admin", "edusko_admin"],
         },
         {
            label: "School",
            url: "#/admin/school/add",
            icon: "/icons/school.svg",
            role: ["sch_admin", "super_admin", "edusko_admin", "edusko_sub_admin"],
            children: [
               {
                  label: "Add School",
                  url: "/admin/school/add",
               },
               {
                  label: "Manage Schools",
                  url: "/admin/school/overview",
               },
            ],
         },
         {
            label: "Summer Camp",
            url: "/admin/summer-camp",
            icon: "/icons/summer.svg",
            role: ["super_admin", "sch_admin", "edusko_admin", "edusko_sub_admin"],
         },
         {
            label: "Financial Partner",
            url: "/admin/financial-partners/dashboard",
            icon: "/icons/finan.svg",
            role: ["super_admin"],
         },
         {
            label: "Education Finance",
            url: "/admin/education-finance",
            icon: "/icons/studyAbroad.svg",
            role: ["super_admin", "edusko_admin", "edusko_sub_admin"],
         },
         {
            label: "Loan Applications",
            url: "/admin/loan-applications",
            icon: "/icons/coins.svg",
            role: ["super_admin", "edusko_admin", "edusko_sub_admin"],
         },
         {
            label: "Finance Dashboard",
            url: "/admin/finance/dashboard",
            icon: "/icons/financeDash.svg",
            role: ["loan_manager"],
         },
         {
            label: "Applications",
            url: "/admin/finance/applications",
            icon: "/icons/financeApplications.svg",
            role: ["loan_manager"],
         },
         {
            label: "Products",
            url: "#/admin/products",
            icon: "/icons/financeProducts.svg",
            role: ["loan_manager"],
            children: [
               {
                  label: "All Products",
                  url: "/admin/finance/products",
               },
               {
                  label: "Add Product",
                  url: "/admin/finance/add",
               },
            ],
         },
         {
            label: "Subscriptions",
            url: "/admin/school/subscriptions",
            icon: "/icons/sub.svg",
            role: ["sch_admin"],
         },
         {
            label: "CMS",
            url: "#/cms",
            icon: "/images/blog.png",
            role: ["super_admin", "edusko_admin", "edusko_sub_admin"],
            children: [
               {
                  label: "List Blogs",
                  url: "/admin/blog",
               },
               {
                  label: "Add New Blog",
                  url: "/admin/blog/add",
               },
               {
                  label: "Videos",
                  url: "/admin/videos",
               },
               {
                  label: "Adverts",
                  url: "/admin/adverts",
               },
               {
                  label: "News",
                  url: "/admin/news",
               },
               {
                  label: "Testimonials",
                  url: "/admin/testimonials",
               },
               {
                  label: "Edusko Board",
                  url: "/admin/edusko-board",
               },
               {
                  label: "School Admins",
                  url: "/admin/school-admins",
               },
               {
                  label: "Add Board Member",
                  url: "/admin/edusko-board/add",
               },
               {
                  label: "Notifications",
                  url: "/admin/notifications",
               },
            ],
         },
         {
            label: "Study Abroad",
            url: "#/admin/study-abroad-admin",
            icon: "/icons/studyAbroad.svg",
            role: ["super_admin", "edusko_admin", "edusko_sub_admin"],
            children: [
               {
                  label: "Partners",
                  url: "/admin/study-abroad-admin/partners",
               },
               // {
               //    label: "Courses",
               //    url: "/admin/study-abroad-admin/courses"
               // },
               {
                  label: "Scholarship",
                  url: "/admin/study-abroad-admin/scholarships",
               },
               {
                  label: "Enquiries",
                  url: "/admin/study-abroad-admin/requests",
               },
               {
                  label: "Applications",
                  url: "/admin/study-abroad-admin/applications",
               },
            ],
         },
         {
            label: "Market Place",
            url: "#/admin/market-place",
            icon: "/icons/market.svg",
            role: ["super_admin", "edusko_admin", "edusko_sub_admin"],
            children: [
               {
                  label: "Vendors",
                  url: "/admin/market-place/vendors",
               },
               {
                  label: "Categories",
                  url: "/admin/market-place/categories",
               },
               {
                  label: "Payment",
                  url: "/admin/market-place/payment",
               },
            ],
         },
         {
            label: "User Management",
            url: "/admin/users",
            icon: "/images/users.png",
            role: ["super_admin"],
         },
         {
            label: "Account Settings",
            url: "#/admin/user",
            icon: "/images/user.png",
            role: ["super_admin", "edusko_sub_admin", "edusko_admin"],
            children: [
               {
                  label: "Account",
                  url: "/admin/user/account",
               },
               {
                  label: "Change Password",
                  url: "/admin/user/change-password",
               },
            ],
         },
         {
            label: "Dashboard",
            url: "/admin/study-abroad-partner/dashboard",
            icon: "/icons/dashboard.svg",
            role: ["study_abroad_partner"],
         },
         {
            label: "Applications",
            url: "/admin/study-abroad-partner/applications",
            icon: "/icons/applicationicon.png",
            role: ["study_abroad_partner"],
         },
         {
            label: "Courses",
            url: "/admin/study-abroad-partner/courses",
            icon: "/icons/coursesicon.png",
            role: ["study_abroad_partner"],
         },
         {
            label: "Scholarship",
            url: "/admin/study-abroad-partner/scholarship",
            icon: "/icons/scholaricon.png",
            role: ["study_abroad_partner"],
         },
         {
            label: "Account Settings",
            url: "#/admin/study-abroad-partner/settings",
            icon: "/icons/settingicon.png",
            role: ["study_abroad_partner"],
            children: [
               {
                  label: "Account",
                  url: "/admin/study-abroad-partner/settings/user-account",
               },
               {
                  label: "Change Password",
                  url: "/admin/study-abroad-partner/settings/change-password",
               },
            ],
         },
         {
            label: "Dashboard",
            url: "/admin/vendor/dashboard",
            icon: "/icons/dashboard.svg",
            role: ["vendor"],
         },
         {
            label: "Orders",
            url: "/admin/vendor/orders",
            icon: "/icons/orders.svg",
            role: ["vendor"],
         },
         {
            label: "Profile",
            url: "/admin/vendor/profile",
            icon: "/icons/combined-shape.svg",
            role: ["vendor"],
         },
      ];
   }, []);

   const currentLinks = links.reduce<Record<string, string>[]>((acc, item: any) => {
      if (item.role?.includes(user?.type)) {
         acc.push(item);
      }
      return acc;
   }, []);

   return {
      currentLinks,
   };
}
